import BaseAPIService from './BaseAPIService';

export default class CampaignService extends BaseAPIService {
	constructor() {
		super();
	}

	async getCampaign() {
		const id = process.env.VUE_APP_CAMPAIGN_ID;
		const query = require('@/graphql/queries/campaign.gql');
		const variables = { id };
		const result = await this.query({ query, variables });
		return result.data.campaign;
	}
}
